import React from 'react';

// Bloque con mini-título en mayúsculas (ej. "QUÉ CAMBIÓ", "CAMPAÑAS AFECTADAS").
export function DetailSection({title, children}) {
    return (
        <div className="ald-section">
            {title ? <div className="ald-section-title">{title}</div> : null}
            {children}
        </div>
    );
}
